import { createSelector } from 'reselect'

const tasks = (state = {}) => state?.tasks || {}

export const addActionUpdateList$ = createSelector(
  tasks,
  (tasks = {}) => tasks?.addActionUpdateList || false
)
export const addTaskModalInitialValue$ = createSelector(
  tasks,
  (tasks = {}) => tasks?.addTaskModalInitialValue || null
)
export const isAddTaskModalVisible$ = createSelector(
  tasks,
  (tasks = {}) => tasks?.isAddTaskModalVisible || false
)
